export default __webpack_public_path__ + "static/media/icon-delete-alt.6e0da2b4.svg";